import s from'./../libs/rollup-plugin-styles/dist/runtime/inject-css.mjs';var l=l=>{"undefined"==typeof document&&(global.ssrStyles?global.ssrStyles.push(l):global.ssrStyles=[]),s(l,{singleTag:!0})};export{l as default};
//# sourceMappingURL=inject-css.mjs.map
